import { QuestionTextField, QuestionDropDownField, QuestionGiinField, QuestionYesNoField, QuestionStockMarketAutocompleteField } from 'components/Questionnaires/fields';
import { QuestionAddressBlock, QuestionUsTinBlock, QuestionGiinBlock, QuestionTaxResidenceBlock, QuestionBlockRepeater, QuestionControllingPersonBlock, QuestionSignerBlock } from 'components/Questionnaires/blocks';
import { requiredValidator, lengthValidator } from 'components/Questionnaires/validators';
import { incorporationCountryBlock } from './blocks/blocks';

const fatcaCrsE = {
  blocks: [
    {
      id: 'name',
      title: 'questionnaire.crs.e.name',
      component: undefined, // Component for Block
      visible: true,
      questions: [
        {
          id: 'name',
          label: 'questionnaire.crs.e.name.label',
          component: QuestionTextField,
          info: {
            instructions: 'questionnaire.crs.e.name.info'
          },
          visible: true,
          lockGroup: 'name',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.name.errorMessage' }
            ]
          }
        },
      ]
    },
    incorporationCountryBlock(),
    {
      id: 'address',
      title: 'questionnaire.address',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.address.1.label'
      },
      info: {
        instructions: 'questionnaire.address.1.info'
      },
      visible: true,
      lockGroup: 'permanentAddress',
    },
    {
      id: 'mailingAddress',
      title: 'questionnaire.mailingAddress',
      component: QuestionAddressBlock,
      componentProps: {
        line1Label: 'questionnaire.mailingAddress.1.label',
        optional: true
      },
      info: {
        instructions: 'questionnaire.mailingAddress.1.info'
      },
      linkBlock: true,
      visible: true,
      lockGroup: 'mailingAddress',
    },
    {
      id: 'taxResidences',
      title: 'questionnaire.taxResidences',
      component: QuestionBlockRepeater,
      componentProps: {
        collapsible: true
      },
      repeatBlock: {
        id: 'taxResidence',
        title: 'questionnaire.taxResidence',
        component: QuestionTaxResidenceBlock
      },
      minSize: 1,
      maxSize: 5,
      addText: 'questionnaire.taxResidences.addLabel',
      visible: true,
    },
    {
      id: 'usDetermination',
      title: 'questionnaire.fatcacrs.usDetermination',
      info: {
        instructions: 'questionnaire.fatcacrs.usDetermination.info'
      },
      questions: [
        {
          id: 'isUsPerson',
          label: 'questionnaire.fatcacrs.usDetermination.label',
          component: QuestionYesNoField,
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.usDetermination.errorMessage' }
            ]
          }
        }
      ],
      visible: true
    },
    {
      id: 'usTin',
      title: 'questionnaire.usTin',
      component: QuestionUsTinBlock,
      componentProps: {
        showAppliedFor: false,
        default: 'Ein'
      },
      info: {
        footnote: 'questionnaire.usTin.footnote'
      },
      visible: (qAnswers, preQualAnswers) => qAnswers?.usDetermination?.isUsPerson === 'Yes'
    },
    {
      id: 'entityType',
      title: 'questionnaire.fatcacrs.e.entityType',
      component: undefined, // Component for Block,
      visible: true,
      questions: [
        {
          id: 'type',
          label: 'questionnaire.fatcacrs.e.entityType.type.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.fatcacrs.e.entityType.type.items'
          },
          info: {
            instructions: 'questionnaire.fatcacrs.e.entityType.type.info'
          },
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.entityType.type.errorMessage' }
            ]
          }
        },
        {
          id: 'fatcaType',
          label: 'questionnaire.fatcacrs.e.entityType.fatcaType.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.fatcacrs.e.entityType.fatcaType.items'
          },
          className: 'col-6',
          info: {
            instructions: 'questionnaire.fatcacrs.e.entityType.fatcaType.info'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => qAnswers?.usDetermination?.isUsPerson === 'No' && bAnswers?.type === 'FinancialInstitution',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.entityType.fatcaType.errorMessage' }
            ]
          }
        },
        {
          id: 'crsType',
          label: 'questionnaire.fatcacrs.e.entityType.crsType.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.fatcacrs.e.entityType.crsType.items'
          },
          className: 'col-6',
          info: {
            instructions: 'questionnaire.fatcacrs.e.entityType.crsType.info'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'FinancialInstitution',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.entityType.crsType.errorMessage' }
            ]
          }
        },
        {
          id: 'fatcaOther',
          label: 'questionnaire.fatcacrs.e.entityType.fatcaOther.label',
          component: QuestionTextField,
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'FinancialInstitution' && bAnswers?.fatcaType === 'Other',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.entityType.fatcaOther.errorMessage' }
            ]
          }
        },
        {
          id: 'crsOther',
          label: 'questionnaire.fatcacrs.e.entityType.crsOther.label',
          component: QuestionTextField,
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'FinancialInstitution'
            && (bAnswers?.crsType === 'Other'
            || (bAnswers?.crsType === 'InvestmentEntityInNonParticipatingJurisdiction' && bAnswers?.inNonCrsParticipatingCountry === 'No')),
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.entityType.crsOther.errorMessage' }
            ]
          }
        },
        {
          id: 'activeNffeType',
          label: 'questionnaire.crs.e.activeNffeType.label',
          component: QuestionDropDownField,
          componentProps: {
            items: 'questionnaire.fatcacrs.e.activeNffeType.items'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'ActiveNFE',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.activeNffeType.errorMessage' }
            ]
          }
        },
        {
          id: 'relatedEntity',
          label: 'questionnaire.crs.e.relatedEntity.label',
          component: QuestionTextField,
          info: {
            instructions: 'questionnaire.crs.e.relatedEntity.info'
          },
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'ActiveNFE' && bAnswers?.activeNffeType === 'ActiveNfeRegularlyTraded',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.relatedEntity.errorMessage' }
            ]
          }
        },
        {
          id: 'securitiesMarket',
          label: 'questionnaire.ch4.publiclyTradedNffe.securityMarket.label',
          component: QuestionStockMarketAutocompleteField,
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'ActiveNFE' && bAnswers?.activeNffeType === 'ActiveNfeRegularlyTraded',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.crs.e.securitiesMarket.errorMessage' }
            ]
          }
        },
        {
          id: 'usControllingPersons',
          label: 'questionnaire.fatcacrs.e.usControllingPersons.label',
          component: QuestionYesNoField,
          visible: (bAnswers, qAnswers, preQualAnswers) => bAnswers?.type === 'PassiveNFE',
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.usControllingPersons.errorMessage' }
            ]
          }
        },
      ]
    },
    {
      id: 'sponsorTrustee',
      title: 'questionnaire.fatcacrs.e.sponsorTrustee',
      questions: [
        {
          id: 'sponsorTrusteeName',
          label: 'questionnaire.fatcacrs.e.sponsorTrusteeName.label',
          component: QuestionTextField,
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.fatcacrs.e.sponsorTrusteeName.errorMessage' },
            ]
          }
        },
        {
          id: 'sponsorTrusteeGiin',
          label: 'questionnaire.fatcacrs.e.sponsorTrusteeGiin.label',
          component: QuestionGiinField,
          componentProps: {
            length: 16
          },
          info: {
            instructions: 'questionnaire.giin.info'
          },
          visible: true,
          validation: {
            conditions: [
              { condition: requiredValidator, message: 'questionnaire.giin.errorMessage' },
              { condition: lengthValidator, message: 'questionnaire.giin.lengthErrorMessage' }
            ]
          }
        },
      ],
      visible: (qAnswers, preQualAnswers) => qAnswers?.entityType?.type === 'FinancialInstitution'
        && ['TrusteeDocumentedTrust', 'SponsoredCloselyHeldInvestmentVehicle'].includes(qAnswers?.entityType?.fatcaType)
    },
    {
      id: 'giin',
      title: 'questionnaire.giin',
      component: QuestionGiinBlock,
      info: {
        instructions: 'questionnaire.giin.info'
      },
      visible: (qAnswers, preQualAnswers) => (qAnswers?.entityType?.type === 'FinancialInstitution'
        && ['ReportingModel1IgaFfi', 'ReportingModel2IgaFfi', 'ParticipatingFfi', 'SponsoredFfi'].includes(qAnswers?.entityType?.fatcaType)),
    },
    {
      id: 'controllingPersons',
      title: 'questionnaire.crs.e.controllingPersons',
      component: QuestionBlockRepeater, // Component for Block
      visible: (qAnswers, preQualAnswers) => (qAnswers?.entityType?.type === 'PassiveNFE' && qAnswers?.entityType?.usControllingPersons !== undefined)
        || qAnswers?.crsEntityType?.type === 'PassiveNFE'
        || (qAnswers?.entityType?.type === 'FinancialInstitution' && qAnswers?.entityType?.crsType === 'InvestmentEntityInNonParticipatingJurisdiction'),
      repeatBlock: {
        id: 'controllingPerson',
        component: QuestionControllingPersonBlock
      },
      minSize: 1,
      maxSize: 6,
      addText: 'questionnaire.crs.e.controllingPersons.addLabel',
    },
    {
      id: 'signer',
      title: 'questionnaire.signer',
      component: QuestionSignerBlock,
      componentProps: {
        entityOnly: true
      },
      visible: true
    },
  ]
};

export default fatcaCrsE;
